<template>
    <div style="  background: #eeeeee;height: 100vh;">
        <div class="wrap">
            <van-sticky>
                <van-nav-bar title="积分明细" left-arrow @click-left="$router.go(-1)" />
            </van-sticky>
            <van-tabs v-model="active" @click='getactive' title-active-color='#3B6BFB'>
                <van-tab title="全部"></van-tab>
                <van-tab title="转出"></van-tab>
                <van-tab title="收入"></van-tab>
            </van-tabs>
            <!-- 列表 -->
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了" class="recordList">
                <div class="recordItem" v-for="(item,index) in list" :key="index">
                    <div class="itemLeft" style="width: 100%;">
                        <div class="itemMoney" style="display: flex;justify-content: space-between;">
                            <div style="text-align: right;">
                                <span v-show="item.status==0" style="color: #00AEFF;">待审核</span>
                                <span v-show="item.status==1" style="color: #3B6BFB;">已通过</span>
                                <span v-show="item.status==2" style="color: red;">已拒绝</span>
                            </div>

                        </div>
                        <div class="itemMoney" v-if='item.uid!=uid'>
                            会员{{item.member}}向你转账
                        </div>
                        <div class="itemMoney" v-if='item.uid==uid'>
                            向会员111{{item.target_member}}转账
                        </div>
                        <div class="itemMoney">
                            金额:
                            <span v-if='item.uid==uid' style="color: #3B6BFB;">-</span>
                            <span v-if='item.uid!=uid' style="color: red;">+</span>
                            <span>{{item.money}}</span>
                        </div>
                        <div class="itemMoney"> <span>时间:{{item.create_time}}</span></div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>
<script>
    import { transferRecordList } from "@/api/personal";
    export default {
        data() {
            return {
                balance: 0,
                loading: false,
                finished: true,
                activeName: "1",
                active: 0,
                walletype: [],
                list: [],
                uid: '',
                form: {
                    type: 0,
                    page: 1,
                    pagesize: 10
                }
            };
        },
        created() {
            this.onLoad();
        },
        methods: {
            getactive(e) {
                this.form.type = e;
                this.form.page = 1;
                this.list = []
                this.onLoad();
            },
            onLoad() {
                transferRecordList(this.form).then(resp => {
                    this.form.page++;
                    this.uid = resp.uid;
                    let rows = resp.data;
                    this.count = resp.count;
                    this.loading = false;
                    this.finished = false;
                    if (rows == null || rows.length == 0) {
                        this.finished = true;
                        return;
                    }
                    this.list = this.list.concat(rows);
                    if (this.list.length >= this.count) {
                        this.finished = true;
                    }
                });
            }
        }
    };
</script>
<style lang='less' scoped>
    .wrap {
        height: 100%;
        background: #eeeeee;

        .walletTitle {
            color: #343434;
            font-size: 15px;
            margin: 0 0 8.5px 18px;
        }

        .recordList {
            width: 345px;
            border-radius: 8px;
            background: #fff;
            box-sizing: border-box;
            padding: 0 13px;
            margin: 10px auto;

            .recordItem {
                display: flex;
                justify-content: space-between;
                color: #666666;
                padding: 14.5px 0 12.5px;
                border-bottom: 1px solid #c1c1c1;
                font-size: 13px;

                .itemtype {
                    color: #343434;
                }

                .itemMoney {
                    margin-top: 11.5px;

                    span {
                        color: #343434;
                    }
                }

                .itemRight {
                    text-align: right;

                    .itemStatus {
                        font-size: 16px;
                    }

                    .itemTime {
                        margin-top: 10px;
                    }
                }
            }
        }
    }

    /deep/ .van-tabs__line {
        background-color: #3B6BFB;
    }
</style>